import { Action } from '@ngrx/store';
import { USERS_CREATE, USERS_DELETE, USERS_FETCH, USERS_INVITATION_RESEND } from '../action-types';
import { GROUP_USERS } from '../state-groups';
import { ListItemSetAction, ListItemUnsetAction, ListSetAction, ListSetFetchingAction } from '../shared/list/list.actions';
import { USER_ENTITY } from '../entity-types';
import { SharedAction } from '../shared/actions/shared-action';
import { CreateUserRequest } from '@core/models/user/create-user-request';
import { ObservableAction } from '../shared/actions/observable-action';

export class FetchUsersAction implements Action {
    readonly type = USERS_FETCH;

    constructor(
        public payload?: {
            locationId: string;
        }
    ) {}
}

@ObservableAction()
export class CreateUserAction implements Action {
    readonly type = USERS_CREATE;

    constructor(
        public payload?: {
            request: CreateUserRequest;
        }
    ) {}
}

export class SetUsersAction extends ListSetAction implements Action {
    name = GROUP_USERS;

    constructor(payload: any) {
        super(payload);
        payload.domain = USER_ENTITY;
    }
}

export class SetUsersFetchingAction
    extends ListSetFetchingAction
    implements SharedAction {
    name = GROUP_USERS;

    constructor(payload: any) {
        super(payload);
    }
}

export class SetUserAction extends ListItemSetAction implements SharedAction {
    name = GROUP_USERS;

    constructor(payload: any) {
        super(payload);
        payload.domain = USER_ENTITY;
    }
}

export class UnsetUserAction extends ListItemUnsetAction implements SharedAction {
    name = GROUP_USERS;

    constructor(payload: any) {
        super(payload);
        payload.domain = USER_ENTITY;
    }
}

@ObservableAction()
export class ResendUserInvitationAction implements Action {
    readonly type = USERS_INVITATION_RESEND;

    constructor(
        public payload?: {
            userId: string;
        }
    ) {}
}

@ObservableAction()
export class DeleteUserAction implements Action {
    readonly type = USERS_DELETE;

    constructor(
        public payload?: {
            userId: string;
        }
    ) {}
}
